<template>
	<dashboard-panel
		:title="cfg.title"
		:edit-mode="editMode"
		:popout-url="`/app/${cfg.settingsFile}`"
		:popout-width="400"
		:popout-height="280"
		@remove="$emit('remove')"
	>
		<panel-lock v-if="locked" message="Goal widgets are available for subscribers." />
		<div v-else class="goal-panel p-2 overflow-auto">
			<component :is="cfg.settingsContent" />
		</div>
	</dashboard-panel>
</template>

<script>
import DashboardPanel from '../DashboardPanel.vue';
import GiftGoalSettingsContent from '../Widget/GiftGoalSettingsContent.vue';
import SubGoalSettingsContent from '../Widget/SubGoalSettingsContent.vue';
import FollowerGoalSettingsContent from '../Widget/FollowerGoalSettingsContent.vue';
import PanelLock from './PanelLock.vue';

// Per-kind wiring: title, popout settings page, and which quick-settings (value fields)
// component to render — the same compact form used by the settings popout.
const KINDS = {
	gift: {
		title: 'Donation goal', settingsFile: 'giftGoalSettings.html',
		settingsContent: 'GiftGoalSettingsContent',
	},
	sub: {
		title: 'Membership goal', settingsFile: 'subGoalSettings.html',
		settingsContent: 'SubGoalSettingsContent',
	},
	follower: {
		title: 'Follower goal', settingsFile: 'followerGoalSettings.html',
		settingsContent: 'FollowerGoalSettingsContent',
	},
};

export default {
	name: 'GoalPanel',
	components: {
		DashboardPanel, PanelLock,
		GiftGoalSettingsContent, SubGoalSettingsContent, FollowerGoalSettingsContent,
	},
	props: {
		editMode: { type: Boolean, default: false },
		// 'gift' | 'sub' | 'follower'
		kind: { type: String, required: true },
		user: { type: Object, default: () => ({}) },
	},
	computed: {
		cfg() { return KINDS[this.kind] || KINDS.gift; },
		locked() { return Array.isArray(this.user && this.user.permissions) && !this.user.permissions.includes('extra_widgets'); },
	},
};
</script>
